import { useEffect } from 'react';
import { toast as toastLib } from 'react-toastify';
import toast, { ToastContainer } from '#/components/toasts/toast';
import { mirage } from '@paradigm/design-system/src/colors';
import { PlatformStateView } from '@paradigm/features/src/platform-state/contexts/store';
import { ToastNotification } from './styles';

interface PlatformStateMessages {
  platformState?: string;
  nextPlatformState: string;
  nextPlatformStateAt?: string;
}

interface Config {
  readonly platformMessages: PlatformStateMessages;
  readonly color: string;
  readonly noClose: boolean;
}

const containerId = 'platform-state';

interface PlatformStateHandlerProps {
  usePlatformStateView: () => PlatformStateView;
  position?: 'top-right' | 'top-center';
}

export default function PlatformStateHandler({
  usePlatformStateView,
  position = 'top-right',
}: PlatformStateHandlerProps) {
  const { data, notification } = usePlatformStateView();
  const { shouldNotify, closable, color, hidePlatformState } = notification;
  const { platformState, nextPlatformState, nextPlatformStateAt } = data;

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (shouldNotify) {
        notifyUser({
          color,
          noClose: !closable,
          platformMessages: {
            nextPlatformState,
            nextPlatformStateAt,
            platformState: !hidePlatformState ? platformState : undefined,
          },
        });
      }
    }, 500);

    return () => {
      clearTimeout(debounce);
    };
  }, [
    data,
    nextPlatformState,
    nextPlatformStateAt,
    platformState,
    shouldNotify,
    color,
    closable,
    hidePlatformState,
  ]);

  return (
    <ToastContainer
      draggable={false}
      position={position}
      containerId={containerId}
    />
  );
}

const notifyUser = ({ platformMessages, color, noClose }: Config) => {
  toastLib.dismiss();
  toast(<ToastNotification message={platformMessages} color={color} />, {
    noClose,
    containerId,
    icon: false,
    styles: {
      backgroundColor: mirage,
      borderColor: 'transparent',
      color: '#fff',
      padding: '0px 0px',
      content: {
        margin: '0px',
      },
    },
  });
};
